const products = [

    {
        id: 1,
        name: "Clean",
        technical: "Chlorpyrifos 50%",
        formulation: "EC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/1.jpeg",
        description: "Clean is a powerful broad-spectrum insecticide containing Chlorpyrifos 50% EC. It provides effective control over sucking and chewing pests such as borers, termites, aphids, and caterpillars in a wide range of crops. Clean ensures quick knockdown action and long-lasting protection, helping farmers achieve healthier crops and higher yields."
    },
    {
        id: 2,
        name: "Super Bio",
        technical: "Bio nutrients (Organic Biostimulant)",
        formulation: "Liquid",
        category: "Plant Growth Regulator",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/2.jpeg",
        description: "Super Bio is an advanced organic biostimulant enriched with bio nutrients that enhances plant growth, improves root development, and increases nutrient uptake. It strengthens crop immunity, promotes lush green foliage, and boosts overall yield and quality in all types of crops."
    },
    {
        id: 3,
        name: "Sulfa Wait 80",
        technical: "Sulphur 80%",
        formulation: "WDG",
        category: "Fertilizer",
        packSize: "3 Kg",
        image: "/images/products/3.jpeg",
        description: "Sulfa Wait 80 is a high-concentration sulphur fertilizer that corrects sulphur deficiency and improves protein synthesis in crops. It enhances oil content, improves crop quality, and also provides protection against fungal diseases and mites, resulting in healthier and more productive plants."
    },
    {
        id: 4,
        name: "V-Star",
        technical: "Azoxystrobin 18.2% + Difenoconazole 11.4%",
        formulation: "SC",
        category: "Fungicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/4.jpeg",
        description: "V-Star is a powerful combination fungicide that provides both preventive and curative control of major fungal diseases. It effectively controls leaf spot, powdery mildew, rust, and blight while improving crop health and ensuring long-lasting protection for higher yield and better quality produce."
    },
    {
        id: 5,
        name: "Matree",
        technical: "Metribuzin 42% + Clodinafop Propargyl 12%",
        formulation: "WG",
        category: "Herbicide",
        packSize: "1 kg, 500 gm, 250 gm, 100 gm",
        image: "/images/products/5.jpeg",
        description: "Matree is a selective herbicide that provides excellent control of both grassy and broad-leaf weeds in wheat and other crops. Its dual-action formula ensures effective weed management, allowing crops to grow without competition for nutrients, water, and sunlight."
    },
    {
        id: 6,
        name: "M-75",
        technical: "Mancozeb 75%",
        formulation: "WP",
        category: "Fungicide",
        packSize: "1 kg, 500 gm, 250 gm, 100 gm",
        image: "/images/products/6.jpeg",
        description: "M-75 is a contact fungicide containing Mancozeb 75% WP that offers broad-spectrum protection against a wide range of fungal diseases. It effectively controls blights, leaf spots, and downy mildew, protecting crops and improving overall productivity."
    },
    {
        id: 7,
        name: "Dumdar",
        technical: "Lambda-cyhalothrin 4.9%",
        formulation: "CS",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/7.jpeg",
        description: "Dumdar is a fast-acting insecticide that controls a wide range of sucking and chewing pests including bollworms, aphids, jassids, and caterpillars. Its capsule suspension formulation provides longer residual activity and quick knockdown for reliable crop protection."
    },
    {
        id: 8,
        name: "Weelcor",
        technical: "Metribuzin 70%",
        formulation: "WP",
        category: "Herbicide",
        packSize: "1 Kg",
        image: "/images/products/8.jpeg",
        description: "Weelcor is a selective herbicide used for effective control of broad-leaf and grassy weeds in potato, soybean, and wheat. It ensures early-season weed control, improves crop establishment, and helps achieve higher yields."
    },
    {
        id: 9,
        name: "Pyweel",
        technical: "Paclobutrazol 23%",
        formulation: "SC",
        category: "Plant Growth Regulator",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/9.jpeg",
        description: "Pyweel is a plant growth regulator that controls excessive vegetative growth and promotes better flowering and fruiting. It improves crop architecture, enhances stress tolerance, and increases yield and quality, especially in fruit and plantation crops."
    },
    {
        id: 10,
        name: "Raksha-FS",
        technical: "Thiamethoxam 30%",
        formulation: "FS",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/10.jpeg",
        description: "Raksha-FS is a systemic seed treatment insecticide that protects crops from early-stage pests such as aphids, jassids, and thrips. It ensures healthy crop establishment, strong root development, and long-lasting protection right from germination."
    },
    {
        id: 11,
        name: "Parweel",
        technical: "Fipronil 4% + Acetamiprid 4% SC",
        formulation: "SC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml, 100 ml",
        image: "/images/products/11.jpeg",
        description: "Parweel is a dual-action insecticide combining Fipronil and Acetamiprid for powerful control of sucking and chewing pests. It effectively manages aphids, jassids, thrips, and termites while providing long-lasting systemic and contact protection for healthier crops."
    },
    {
        id: 12,
        name: "PANKIBA",
        technical: "Profenofos 40% + Fenpyroximate 2.5% EC",
        formulation: "EC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/12.jpeg",
        description: "PANKIBA is a broad-spectrum insecticide and acaricide that controls mites and insect pests such as whiteflies, thrips, and caterpillars. Its strong contact and systemic action ensures quick knockdown and extended protection across multiple crops."
    },
    {
        id: 13,
        name: "Double Attack",
        technical: "Emamectin Benzoate 1.9% EC",
        formulation: "EC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml, 100 ml, 20 ml",
        image: "/images/products/13.jpeg",
        description: "Double Attack is a highly effective insecticide for the control of lepidopteran pests like fruit borers and caterpillars. It provides rapid action, translaminar movement, and long residual control, ensuring maximum crop protection and higher yield."
    },
    {
        id: 14,
        name: "DUMEEL",
        technical: "Metalaxyl 8% + Mancozeb 64% WP",
        formulation: "WP",
        category: "Fungicide",
        packSize: "1 kg, 500 gm, 250 gm, 100 gm",
        image: "/images/products/14.jpeg",
        description: "DUMEEL is a systemic and contact fungicide that provides excellent protection against downy mildew, late blight, and damping-off. Its dual mode of action ensures preventive and curative control for healthier crops and improved productivity."
    },
    {
        id: 15,
        name: "Hodiyo",
        technical: "Pyraclostrobin 20% WG",
        formulation: "WG",
        category: "Fungicide",
        packSize: "1 kg, 500 gm, 250 gm",
        image: "/images/products/15.jpeg",
        description: "Hodiyo is a modern strobilurin fungicide that enhances plant vitality while controlling major fungal diseases such as rust, leaf spot, and powdery mildew. It improves photosynthesis efficiency, resulting in greener plants and higher yields."
    },
    {
        id: 16,
        name: "VIGOT",
        technical: "Cypermethrin 3% + Quinalphos 20% EC",
        formulation: "EC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/16.jpeg",
        description: "VIGOT is a powerful combination insecticide that controls a wide range of pests including bollworms, stem borers, and leaf folders. It delivers quick knockdown and long residual action, ensuring reliable protection throughout the crop cycle."
    },
    {
        id: 17,
        name: "HOSH",
        technical: "Gibberellic Acid 0.001% L",
        formulation: "Liquid",
        category: "Plant Growth Regulator",
        packSize: "1 L, 500 ml, 250 ml, 100 ml",
        image: "/images/products/17.jpeg",
        description: "HOSH is a plant growth regulator that promotes cell elongation, improves flowering, and enhances fruit set. It helps achieve uniform growth, better crop establishment, and improved yield and quality across various crops."
    },
    {
        id: 18,
        name: "RIGO",
        technical: "Pretilachlor 50% EC",
        formulation: "EC",
        category: "Herbicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/18.jpeg",
        description: "RIGO is a pre-emergence herbicide for effective control of grassy and broad-leaf weeds in transplanted rice. It prevents early weed competition, supports strong crop establishment, and improves overall yield potential."
    },
    {
        id: 19,
        name: "Prime",
        technical: "Emamectin Benzoate 5% SG",
        formulation: "SG",
        category: "Insecticide",
        packSize: "1 kg, 500 gm, 250 gm, 100 gm, 10 gm",
        image: "/images/products/19.jpeg",
        description: "Prime is a highly potent insecticide for the control of fruit borers and caterpillars. Its translaminar action provides long-lasting protection, ensuring effective pest management and improved crop productivity."
    },
    {
        id: 20,
        name: "GOSTIN",
        technical: "Carbendazim 50% WP",
        formulation: "WP",
        category: "Fungicide",
        packSize: "1 Kg",
        image: "/images/products/20.jpeg",
        description: "GOSTIN is a systemic fungicide that controls a wide range of fungal diseases including leaf spot, wilt, and anthracnose. It provides both preventive and curative action, keeping crops healthy and productive."
    },
    {
        id: 21,
        name: "GB 186",
        technical: "Gibberellic Acid 0.186%",
        formulation: "SP",
        category: "Plant Growth Regulator",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/21.jpeg",
        description: "GB 186 is a plant growth regulator that stimulates growth, improves flowering, and enhances fruit development. It supports uniform crop growth and helps achieve higher yield and better marketable quality."
    },
    {
        id: 22,
        name: "GINAPA",
        technical: "Fipronil 40% + Imidacloprid 40%",
        formulation: "WG",
        category: "Insecticide",
        packSize: "100 gm",
        image: "/images/products/22.jpeg",
        description: "GINAPA is a high-performance insecticide that provides powerful control of sucking pests and termites. Its dual active ingredients ensure rapid knockdown and extended protection for long-term crop safety."
    },
    {
        id: 23,
        name: "TREET",
        technical: "Propiconazole 25%",
        formulation: "EC",
        category: "Fungicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/23.jpeg",
        description: "TREET is a systemic fungicide effective against rust, leaf spot, and powdery mildew. It protects crops from fungal infections and improves plant vigor, resulting in healthier crops and higher yields."
    },
    {
        id: 24,
        name: "VAMCI",
        technical: "Validamycin 3%",
        formulation: "L",
        category: "Fungicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/24.jpeg",
        description: "VAMCI is a specialized fungicide for the management of sheath blight and other soil-borne diseases. It provides excellent curative action and supports strong crop health in rice and vegetable crops."
    },
    {
        id: 25,
        name: "PED-30",
        technical: "Pendimethalin 30%",
        formulation: "EC",
        category: "Herbicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/25.jpeg",
        description: "PED-30 is a pre-emergence herbicide that effectively controls annual grasses and broad-leaf weeds. It ensures early-season weed management, allowing crops to grow without competition and achieve higher productivity."
    },
    {
        id: 26,
        name: "Salfa-40",
        technical: "Sulphur 40%",
        formulation: "SC",
        category: "Fungicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/26.jpeg",
        description: "Salfa-40 is a sulphur-based fungicide and nutrient that controls powdery mildew and mite infestation while correcting sulphur deficiency. It improves plant health, enhances oil content, and boosts overall crop productivity."
    },
    {
        id: 27,
        name: "WEELOTHRIN",
        technical: "Fenpropathrin 30%",
        formulation: "EC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/27.jpeg",
        description: "WEELOTHRIN is a fast-acting synthetic pyrethroid insecticide for effective control of sucking and chewing pests. It provides quick knockdown and long residual action against thrips, mites, and caterpillars."
    },
    {
        id: 28,
        name: "SOLO 50",
        technical: "Atrazine 50%",
        formulation: "WP",
        category: "Herbicide",
        packSize: "1 kg, 500 gm, 250 gm",
        image: "/images/products/28.jpeg",
        description: "SOLO 50 is a selective pre- and post-emergence herbicide for effective control of broad-leaf and grassy weeds in maize and sugarcane. It ensures clean fields and supports higher yield potential."
    },
    {
        id: 30,
        name: "PARA-CUT / PECAT-24",
        technical: "Paraquat Dichloride 24%",
        formulation: "SL",
        category: "Herbicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/30.jpeg",
        description: "PARA-CUT / PECAT-24 is a non-selective contact herbicide for quick control of existing weeds. It provides rapid desiccation of green plant parts, helping farmers manage weeds efficiently before planting or between crop rows."
    },
    {
        id: 31,
        name: "E-SUPER",
        technical: "Ethion 40% + Cypermethrin 5%",
        formulation: "EC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml, 100 ml",
        image: "/images/products/31.jpeg",
        description: "E-SUPER is a combination insecticide that controls a wide range of insects including borers, leaf folders, and sucking pests. It delivers quick knockdown and extended protection for reliable crop safety."
    },
    {
        id: 32,
        name: "FIRE-D",
        technical: "2,4-D Amine Salt 58%",
        formulation: "SL",
        category: "Herbicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/32.jpeg",
        description: "FIRE-D is a selective post-emergence herbicide for control of broad-leaf weeds in cereal crops. It eliminates weed competition and helps crops grow stronger and healthier."
    },
    {
        id: 33,
        name: "JAMKU",
        technical: "Fipronil 80%",
        formulation: "WG",
        category: "Insecticide",
        packSize: "250 gm, 100 gm",
        image: "/images/products/33.jpeg",
        description: "JAMKU is a high-strength insecticide for effective control of termites, stem borers, and soil insects. It provides long-lasting protection and ensures strong crop establishment."
    },
    {
        id: 34,
        name: "KILLDOR GR",
        technical: "Imidacloprid 0.3%",
        formulation: "GR",
        category: "Insecticide",
        packSize: "1 Kg",
        image: "/images/products/34.jpeg",
        description: "KILLDOR GR is a granular insecticide used for soil application to control termites and early-stage sucking pests. It provides prolonged protection and supports healthy crop growth."
    },
    {
        id: 36,
        name: "GEEFUN",
        technical: "Tolfenpyrad 15%",
        formulation: "EC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/36.jpeg",
        description: "GEEFUN is a modern insecticide for effective control of thrips, mites, and whiteflies. It delivers quick action with long residual control, ensuring reliable pest management in vegetables and fruits."
    },
    {
        id: 37,
        name: "ACEBU",
        technical: "Buprofezin 15% + Acephate 35%",
        formulation: "WP",
        category: "Insecticide",
        packSize: "1 kg, 500 gm, 250 gm, 100 gm",
        image: "/images/products/37.jpeg",
        description: "ACEBU is a combination insecticide that controls hopper, whitefly, and leaf miner populations. It provides both contact and systemic action for long-lasting and effective pest control."
    },
    {
        id: 38,
        name: "OXYGEN",
        technical: "Oxyfluorfen 23.5%",
        formulation: "EC",
        category: "Herbicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/38.jpeg",
        description: "OXYGEN is a pre- and post-emergence herbicide for broad-leaf weed control in onion, cotton, and vegetables. It ensures clean fields and better crop establishment."
    },
    {
        id: 39,
        name: "LITHOM",
        technical: "Thiamethoxam 12.6% + Lambda-Cyhalothrin 9.5%",
        formulation: "ZC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/39.jpeg",
        description: "LITHOM is a dual-mode insecticide that provides quick knockdown and long-lasting control of sucking and chewing pests. It effectively manages aphids, jassids, thrips, and caterpillars for healthier crops."
    },
    {
        id: 40,
        name: "STAR",
        technical: "Acephate 75%",
        formulation: "SP",
        category: "Insecticide",
        packSize: "1 kg, 500 gm, 250 gm, 100 gm",
        image: "/images/products/40.jpeg",
        description: "STAR is a systemic insecticide for control of sucking pests such as aphids, jassids, and thrips. It provides reliable protection and helps maintain vigorous crop growth and higher yields."
    },
    {
        id: 41,
        name: "MONO SUPER",
        technical: "Monocrotophos 36%",
        formulation: "SL",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/41.jpeg",
        description: "MONO SUPER is a systemic insecticide that controls a wide range of sucking and chewing pests including aphids, jassids, and stem borers. It provides quick action and deep penetration for long-lasting crop protection."
    },
    {
        id: 42,
        name: "SINECAS",
        technical: "Lambda-cyhalothrin 4.9%",
        formulation: "CS",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/42.jpeg",
        description: "SINECAS is a capsule suspension insecticide that delivers fast knockdown and extended residual control of major insect pests. It effectively manages bollworms, caterpillars, and sucking pests for healthier crops."
    },
    {
        id: 43,
        name: "REXWEEL",
        technical: "Tebuconazole 2%",
        formulation: "DS",
        category: "Fungicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/43.jpeg",
        description: "REXWEEL is a seed dressing fungicide that protects crops from seed-borne and soil-borne fungal diseases. It ensures healthy germination, strong seedling vigor, and better crop establishment."
    },
    {
        id: 44,
        name: "MEKO",
        technical: "Thiophanate Methyl 70%",
        formulation: "WP",
        category: "Fungicide",
        packSize: "500 gm",
        image: "/images/products/44.jpeg",
        description: "MEKO is a systemic fungicide that controls leaf spot, powdery mildew, and blight diseases. It provides both preventive and curative action, keeping crops healthy and productive."
    },
    {
        id: 45,
        name: "NANDABA",
        technical: "Chlorpyrifos 16% + Alphacypermethrin 1%",
        formulation: "EC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/45.jpeg",
        description: "NANDABA is a combination insecticide that offers broad-spectrum control of termites, borers, and sucking pests. It provides quick knockdown with long residual protection for safer and healthier crops."
    },
    {
        id: 48,
        name: "HEXA-P",
        technical: "Hexaconazole 5%",
        formulation: "SC",
        category: "Fungicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/48.jpeg",
        description: "HEXA-P is a systemic fungicide effective against powdery mildew, rust, and leaf spot. It protects crops with long-lasting action and improves plant vigor and yield quality."
    },
    {
        id: 49,
        name: "KOSTA",
        technical: "Quinalphos 5%",
        formulation: "GR",
        category: "Insecticide",
        packSize: "1 Kg",
        image: "/images/products/49.jpeg",
        description: "KOSTA is a granular insecticide for soil application to control termites and soil insects. It provides prolonged protection and supports strong root development and healthy crop growth."
    },
    {
        id: 51,
        name: "MUREMI",
        technical: "Novaluron 5.25% + Emamectin Benzoate 0.9%",
        formulation: "SC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/51.jpeg",
        description: "MUREMI is a powerful combination insecticide for the control of caterpillars and fruit borers. It offers quick action and long residual control, ensuring reliable protection and higher yield."
    },
    {
        id: 52,
        name: "Goodweel-6G",
        technical: "Carbosulfan 6%",
        formulation: "G",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/52.jpeg",
        description: "Goodweel-6G is a granular insecticide for soil and nursery application to control stem borers and soil pests. It ensures early protection and supports healthy crop establishment."
    },
    {
        id: 53,
        name: "RUSH",
        technical: "Novaluron 5.25% + Indoxacarb 4.5%",
        formulation: "SC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/53.jpeg",
        description: "RUSH is a dual-action insecticide that effectively controls caterpillars, bollworms, and fruit borers. It provides quick knockdown and long-lasting protection for improved crop safety and productivity."
    },
    {
        id: 54,
        name: "KISTOPA",
        technical: "Tebuconazole 38.39%",
        formulation: "SC",
        category: "Fungicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/54.jpeg",
        description: "KISTOPA is a highly concentrated systemic fungicide that controls rust, powdery mildew, and leaf spot diseases. It offers long residual action and helps maintain healthy, high-yielding crops."
    },
    {
        id: 55,
        name: "NEEM POWER",
        technical: "Neem Oil (Azadirachtin 0.03% – 300 PPM)",
        formulation: "EC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/55.jpeg",
        description: "NEEM POWER is a natural botanical insecticide that controls sucking pests and mites while being safe for beneficial insects. It improves plant health and provides eco-friendly pest management for sustainable farming."
    },
    {
        id: 56,
        name: "SHIBANDA",
        technical: "Sulfosulfuron 75%",
        formulation: "WG",
        category: "Herbicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/56.jpeg",
        description: "SHIBANDA is a selective post-emergence herbicide for effective control of grassy and broad-leaf weeds in wheat. It eliminates weed competition and supports strong, uniform crop growth for higher yields."
    },
    {
        id: 58,
        name: "GOODLUX DP",
        technical: "Quinalphos 1.5%",
        formulation: "DP",
        category: "Insecticide",
        packSize: "1 Kg",
        image: "/images/products/58.jpeg",
        description: "GOODLUX DP is a dust formulation insecticide for quick control of leaf-eating and sucking pests. It provides rapid knockdown and reliable protection in vegetables and field crops."
    },
    {
        id: 59,
        name: "KENZO",
        technical: "Indoxacarb 14.5% + Acetamiprid 7.7%",
        formulation: "SC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/59.jpeg",
        description: "KENZO is a powerful combination insecticide that controls caterpillars, borers, and sucking pests. It offers quick action with long residual control for dependable crop protection."
    },
    {
        id: 60,
        name: "WIPER 9.3",
        technical: "Fenoxaprop-p-ethyl 9.3%",
        formulation: "EC",
        category: "Herbicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/60.jpeg",
        description: "WIPER 9.3 is a selective post-emergence herbicide for control of grassy weeds in wheat and onion. It ensures clean fields and helps crops achieve higher productivity."
    },
    {
        id: 61,
        name: "MAGIC",
        technical: "Triacontanol 0.1%",
        formulation: "EW",
        category: "Plant Growth Regulator",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/61.jpeg",
        description: "MAGIC is a plant growth promoter that enhances photosynthesis, improves flowering, and increases fruit set. It boosts plant vigor and helps achieve higher yield and better quality produce."
    },
    {
        id: 62,
        name: "SAIF",
        technical: "Carbendazim 12% + Mancozeb 63%",
        formulation: "WP",
        category: "Fungicide",
        packSize: "500 gm",
        image: "/images/products/62.jpeg",
        description: "SAIF is a combination fungicide that provides broad-spectrum control of major fungal diseases. It offers both preventive and curative action, keeping crops healthy and productive."
    },
    {
        id: 63,
        name: "MERIWEEL",
        technical: "Zineb 75%",
        formulation: "WP",
        category: "Fungicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/63.jpeg",
        description: "MERIWEEL is a contact fungicide effective against blight, leaf spot, and downy mildew. It protects crops with reliable disease control and supports higher yields."
    },
    {
        id: 64,
        name: "MASHKO",
        technical: "Glyphosate Ammonium Salt 20%",
        formulation: "SL",
        category: "Herbicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/64.jpeg",
        description: "MASHKO is a non-selective systemic herbicide for complete weed control. It effectively manages annual and perennial weeds, ensuring clean fields and better crop management."
    },
    {
        id: 66,
        name: "KRNATE",
        technical: "Lambda-cyhalothrin 5%",
        formulation: "EC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml, 100 ml",
        image: "/images/products/66.jpeg",
        description: "KRNATE is a fast-acting insecticide that controls a wide range of insect pests including bollworms, aphids, and jassids. It provides quick knockdown and long residual protection."
    },
    {
        id: 67,
        name: "KILLDOR",
        technical: "Imidacloprid 17.8%",
        formulation: "SL",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml, 100 ml",
        image: "/images/products/67.jpeg",
        description: "KILLDOR is a systemic insecticide for effective control of sucking pests such as aphids, jassids, and whiteflies. It ensures long-lasting protection and healthier crop growth."
    },
    {
        id: 68,
        name: "PARA-CUT",
        technical: "Paraquat Dichloride 24%",
        formulation: "SL",
        category: "Herbicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/68.jpeg",
        description: "PARA-CUT is a non-selective contact herbicide for quick desiccation of weeds. It helps farmers manage weeds efficiently between crop rows and before sowing."
    },
    {
        id: 69,
        name: "Matuli",
        technical: "Azoxystrobin 23%",
        formulation: "SC",
        category: "Fungicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/69.jpeg",
        description: "Matuli is a systemic fungicide that controls major foliar diseases such as rust, leaf spot, and blight. It improves plant health and ensures better yield and quality."
    },
    {
        id: 70,
        name: "GOODLI",
        technical: "Chlorimuron Ethyl 25%",
        formulation: "WP",
        category: "Herbicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/70.jpeg",
        description: "GOODLI is a selective herbicide for effective control of broad-leaf weeds in soybean and pulses. It ensures early weed management and supports higher crop productivity."
    },
    {
        id: 71,
        name: "M-71",
        technical: "Ammonium Salt of Glyphosate 71%",
        formulation: "SG",
        category: "Herbicide",
        packSize: "100 gm",
        image: "/images/products/71.jpeg",
        description: "M-71 is a high-strength systemic herbicide for complete weed control. It effectively controls annual and perennial weeds, ensuring clean fields and better crop management with long-lasting results."
    },
    {
        id: 74,
        name: "GARSU",
        technical: "Quizalofop Ethyl 5%",
        formulation: "EC",
        category: "Herbicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/74.jpeg",
        description: "GARSU is a selective post-emergence herbicide for control of grassy weeds in soybean, cotton, and groundnut. It provides effective weed management and supports higher crop productivity."
    },
    {
        id: 75,
        name: "THION",
        technical: "Ethion 50%",
        formulation: "EC",
        category: "Insecticide",
        packSize: "1 L",
        image: "/images/products/75.jpeg",
        description: "THION is a broad-spectrum insecticide and acaricide that controls mites, thrips, and sucking pests. It provides quick knockdown and reliable protection for healthy crop growth."
    },
    {
        id: 76,
        name: "DOMIS",
        technical: "Deltamethrin 11%",
        formulation: "EC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/76.jpeg",
        description: "DOMIS is a fast-acting pyrethroid insecticide that controls a wide range of insect pests. It offers quick knockdown and long residual control for effective crop protection."
    },
    {
        id: 79,
        name: "DUMEEL",
        technical: "Metalaxyl 8% + Mancozeb 64%",
        formulation: "WP",
        category: "Fungicide",
        packSize: "1 kg, 500 gm, 250 gm, 100 gm",
        image: "/images/products/79.jpeg",
        description: "DUMEEL is a systemic and contact fungicide that protects crops from downy mildew, late blight, and damping-off. It ensures both preventive and curative disease control for healthier crops."
    },
    {
        id: 80,
        name: "TAKRAR",
        technical: "Captan 70% + Hexaconazole 5%",
        formulation: "WP",
        category: "Fungicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/80.jpeg",
        description: "TAKRAR is a powerful combination fungicide that controls major fungal diseases including leaf spot, blight, and anthracnose. It provides long-lasting protection and improves crop vigor and yield."
    },
    {
        id: 81,
        name: "HUMIC GOLD",
        technical: "Humic Acid 15% + Amino Acid 10%",
        formulation: "Liquid",
        category: "Plant Growth Regulator",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/81.jpeg",
        description: "HUMIC GOLD is a premium biostimulant that improves soil health, enhances nutrient uptake, and promotes strong root growth. It increases stress tolerance and boosts overall crop yield and quality."
    },
    {
        id: 82,
        name: "DOUBLE STOP",
        technical: "Pendimethalin 38.7%",
        formulation: "CS",
        category: "Herbicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/82.jpeg",
        description: "DOUBLE STOP is a pre-emergence herbicide for effective control of annual grasses and broad-leaf weeds. It ensures early weed management and supports clean, high-yielding fields."
    },
    {
        id: 83,
        name: "GOOD 32",
        technical: "Pendimethalin 30% + Imazethapyr 2%",
        formulation: "EC",
        category: "Herbicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/83.jpeg",
        description: "GOOD 32 is a combination herbicide that provides broad-spectrum weed control in soybean and pulses. It controls both grassy and broad-leaf weeds for better crop establishment and higher yield."
    },
    {
        id: 84,
        name: "Chipko Plus",
        technical: "Non-ionic Surfactant (Wetting Agent)",
        formulation: "Liquid",
        category: "Others",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/84.jpeg",
        description: "Chipko Plus is a high-quality wetting and spreading agent that improves spray coverage and absorption of agrochemicals. It enhances the effectiveness of pesticides and fertilizers for better crop results."
    },
    {
        id: 88,
        name: "WEELORA",
        technical: "Quizalofop Ethyl 10%",
        formulation: "EC",
        category: "Herbicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/88.jpeg",
        description: "WEELORA is a selective post-emergence herbicide for effective control of grassy weeds in soybean, cotton, and vegetables. It ensures clean fields and helps crops grow without competition for nutrients and moisture."
    },
    {
        id: 91,
        name: "SUPER STOP",
        technical: "Chlormequat Chloride 50%",
        formulation: "SL",
        category: "Plant Growth Regulator",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/91.jpeg",
        description: "SUPER STOP is a plant growth regulator that controls excessive vegetative growth and promotes strong stems and better flowering. It improves crop architecture, reduces lodging, and enhances yield potential."
    },
    {
        id: 96,
        name: "CYSON-DP",
        technical: "Malathion 5%",
        formulation: "DP",
        category: "Insecticide",
        packSize: "25 kg, 10 kg",
        image: "/images/products/96.jpeg",
        description: "CYSON-DP is a dust formulation insecticide for control of household and agricultural pests. It provides quick knockdown and reliable protection against flies, mosquitoes, and crop insect pests."
    },
    {
        id: 97,
        name: "POWER Plus",
        technical: "Silicon based adjuvant",
        formulation: "Liquid",
        category: "Others",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/97.jpeg",
        description: "POWER Plus is a silicon-based adjuvant that improves spray performance by enhancing spreading, sticking, and penetration of agrochemicals. It increases efficacy of pesticides and fertilizers for better crop protection."
    },
    {
        id: 98,
        name: "Fighter-505",
        technical: "Chlorpyriphos 50% + Cypermethrin 5%",
        formulation: "EC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/98.jpeg",
        description: "Fighter-505 is a powerful combination insecticide that controls a wide range of sucking and chewing pests including borers, termites, and caterpillars. It provides quick knockdown and long-lasting protection for healthier crops."
    },
    {
        id: 99,
        name: "COPPER-G",
        technical: "Copper Oxychloride 50%",
        formulation: "WP",
        category: "Fungicide",
        packSize: "1 kg, 500 gm, 250 gm, 100 gm",
        image: "/images/products/99.jpeg",
        description: "COPPER-G is a broad-spectrum contact fungicide for control of blight, leaf spot, and bacterial diseases. It protects crops with reliable disease management and supports higher yield and better quality produce."
    },
    {
        id: 102,
        name: "Runner",
        technical: "Fipronil 2.92%",
        formulation: "EC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/102.jpeg",
        description: "Runner is a reliable insecticide for effective control of termites, stem borers, and sucking pests. Its systemic and contact action ensures quick knockdown and long-lasting protection for healthier crops."
    },
    {
        id: 103,
        name: "Goodweel MONO",
        technical: "Monocrotophos 36%",
        formulation: "SL",
        category: "Insecticide",
        packSize: "1 Ltr",
        image: "/images/products/103.jpeg",
        description: "Goodweel MONO is a systemic insecticide that controls a wide range of chewing and sucking pests. It provides deep penetration and fast action for dependable crop protection."
    },
    {
        id: 104,
        name: "Printed",
        technical: "Imidacloprid 6% + Lambda Cyhalothrin 4%",
        formulation: "SL",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/104.jpeg",
        description: "Printed is a powerful combination insecticide for control of aphids, jassids, thrips, and caterpillars. It delivers quick knockdown with extended residual protection."
    },
    {
        id: 105,
        name: "TIMBA",
        technical: "Dinotefuran 20%",
        formulation: "SG",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/105.jpeg",
        description: "TIMBA is a systemic insecticide effective against sucking pests such as whiteflies, aphids, and thrips. It provides fast action and long-lasting control for improved crop health."
    },
    {
        id: 106,
        name: "ALPHA WEEL",
        technical: "Alphacypermethrin 10%",
        formulation: "EC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/106.jpeg",
        description: "ALPHA WEEL is a fast-acting pyrethroid insecticide for control of bollworms, caterpillars, and sucking pests. It offers quick knockdown and long residual activity."
    },
    {
        id: 107,
        name: "KRISH",
        technical: "Novaluron 5.25% + Indoxacarb 4.5%",
        formulation: "SC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/107.jpeg",
        description: "KRISH is a powerful combination insecticide containing Novaluron and Indoxacarb that effectively controls a wide range of lepidopteran pests. It provides quick knockdown action and long-lasting protection, helping farmers protect crops and improve overall yield."
    },
    {
        id: 110,
        name: "CORBIN 50",
        technical: "Captan 50%",
        formulation: "WP",
        category: "Fungicide",
        packSize: "1 Kg",
        image: "/images/products/110.jpeg",
        description: "CORBIN 50 is a broad-spectrum contact fungicide for control of leaf spot, blight, and fruit rot. It protects crops and improves yield and quality."
    },
    {
        id: 111,
        name: "MAKDA",
        technical: "Fipronil 4% + Thiamethoxam 4%",
        formulation: "SC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/111.jpeg",
        description: "MAKDA is a dual-action insecticide that controls termites, borers, and sucking pests. It provides rapid knockdown and extended protection for safer crops."
    },
    {
        id: 114,
        name: "CYSON",
        technical: "Malathion 50%",
        formulation: "EC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/114.jpeg",
        description: "CYSON is a broad-spectrum insecticide for control of sucking and chewing pests. It delivers quick action and reliable protection across multiple crops."
    },
    {
        id: 115,
        name: "ALPHA WEEL SC",
        technical: "Alphacypermethrin 10%",
        formulation: "SC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/115.jpeg",
        description: "ALPHA WEEL SC is a suspension concentrate formulation offering fast knockdown and long residual control of major insect pests for dependable crop protection."
    },
    {
        id: 116,
        name: "ETHOWEEL",
        technical: "Ethephon 39%",
        formulation: "SL",
        category: "Plant Growth Regulator",
        packSize: "1 L, 500 ml, 250 ml, 100 ml",
        image: "/images/products/116.jpeg",
        description: "ETHOWEEL promotes uniform flowering and fruit ripening, improves maturity, and enhances marketable yield in fruits and vegetables."
    },
    {
        id: 117,
        name: "DHAKAD-G",
        technical: "Novaluron 10%",
        formulation: "EC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/117.jpeg",
        description: "DHAKAD-G is an insect growth regulator that effectively controls caterpillars and borers. It provides long residual control and helps maintain healthy crops."
    },
    {
        id: 118,
        name: "CLEAN",
        technical: "Chlorpyrifos 50%",
        formulation: "EC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/118.jpeg",
        description: "CLEAN is a powerful broad-spectrum insecticide providing effective control of borers, termites, aphids, and caterpillars with quick knockdown and long-lasting protection."
    },
    {
        id: 119,
        name: "CYDOXA",
        technical: "Cypermethrin 10% + Indoxacarb 10%",
        formulation: "SC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/119.jpeg",
        description: "CYDOXA is a combination insecticide for effective control of bollworms and caterpillars. It offers quick action and long residual protection for improved crop safety."
    },
    {
        id: 120,
        name: "TIMBADA",
        technical: "Paclobutrazole 40%",
        formulation: "SC",
        category: "Plant Growth Regulator",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/120.jpeg",
        description: "TIMBADA regulates vegetative growth and promotes better flowering and fruiting, improving crop architecture and yield quality, especially in fruit crops."
    },
    {
        id: 122,
        name: "MANZO",
        technical: "Azoxystrobin 11.5% + Mancozeb 30%",
        formulation: "WP",
        category: "Fungicide",
        packSize: "1 Kg",
        image: "/images/products/122.jpeg",
        description: "MANZO is a broad-spectrum combination fungicide providing preventive and curative control of major foliar diseases. It protects crops from blight, leaf spot, and downy mildew while improving plant vigor and yield."
    },
    {
        id: 123,
        name: "Batity",
        technical: "Buprofezin 22% + Fipronil 3%",
        formulation: "SC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/123.jpeg",
        description: "Batity is a dual-action insecticide for effective control of hoppers, whiteflies, and sucking pests. It offers quick knockdown with long residual protection for healthier crops."
    },
    {
        id: 124,
        name: "E-PRIDE",
        technical: "Acetamiprid 20%",
        formulation: "SP",
        category: "Insecticide",
        packSize: "250 gm, 100 gm",
        image: "/images/products/124.jpeg",
        description: "E-PRIDE is a systemic insecticide for reliable control of aphids, jassids, and whiteflies. It provides fast action and long-lasting protection for improved crop performance."
    },
    {
        id: 125,
        name: "MAJURA",
        technical: "Tricyclazole 18% + Mancozeb 62%",
        formulation: "WP",
        category: "Fungicide",
        packSize: "1 Kg, 500 gm",
        image: "/images/products/125.jpeg",
        description: "MAJURA is a powerful fungicide for effective management of blast and other fungal diseases in rice. It ensures both preventive and curative protection for higher yield and quality."
    },
    {
        id: 126,
        name: "ANTACO",
        technical: "Propineb 70%",
        formulation: "WP",
        category: "Fungicide",
        packSize: "1 kg, 500 gm, 250 gm, 100 gm",
        image: "/images/products/126.jpeg",
        description: "ANTACO is a contact fungicide that controls leaf spot, blight, and scab. It offers reliable disease protection and supports healthy, high-yielding crops."
    },
    {
        id: 127,
        name: "BUTA-50",
        technical: "Butachlor 50%",
        formulation: "EC",
        category: "Herbicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/127.jpeg",
        description: "BUTA-50 is a selective pre-emergence herbicide for control of grassy weeds in rice. It prevents early weed competition and ensures better crop establishment."
    },
    {
        id: 129,
        name: "CORIN",
        technical: "Ziram 27%",
        formulation: "SC",
        category: "Fungicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/129.jpeg",
        description: "CORIN is a contact fungicide for control of leaf spot, blight, and fruit rot. It provides dependable disease management and improves crop quality."
    },
    {
        id: 130,
        name: "SUPER GREEN",
        technical: "Humic Acid 98%",
        formulation: "Powder",
        category: "Plant Growth Regulator",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/130.jpeg",
        description: "SUPER GREEN is a premium humic acid formulation that improves soil health, enhances nutrient uptake, and promotes strong root development for higher yield and better quality."
    },
    {
        id: 132,
        name: "CLODI-15",
        technical: "Clodinafop-propargyl 15%",
        formulation: "WP",
        category: "Herbicide",
        packSize: "160 gm",
        image: "/images/products/132.jpeg",
        description: "CLODI-15 is a selective post-emergence herbicide for effective control of grassy weeds in wheat. It ensures clean fields and improved crop productivity."
    },
    {
        id: 133,
        name: "GOODTRY",
        technical: "Tricyclazole 75%",
        formulation: "WP",
        category: "Fungicide",
        packSize: "1 kg, 500 gm, 250 gm",
        image: "/images/products/133.jpeg",
        description: "GOODTRY is a systemic fungicide for management of rice blast and sheath blight. It provides strong preventive and curative action for healthier crops."
    },
    {
        id: 134,
        name: "Goodlux",
        technical: "Quinalphos 25%",
        formulation: "EC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/134.jpeg",
        description: "Goodlux is a broad-spectrum insecticide for control of borers, caterpillars, and sucking pests. It provides quick knockdown and long-lasting protection."
    },
    {
        id: 135,
        name: "PRO-50",
        technical: "Profenofos 50%",
        formulation: "EC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/135.jpeg",
        description: "PRO-50 is a systemic insecticide effective against bollworms, leaf folders, and sucking pests. It ensures rapid action and dependable crop protection."
    },
    {
        id: 136,
        name: "MOX",
        technical: "Fipronil 4% + Thiamethoxam 4%",
        formulation: "SC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/136.jpeg",
        description: "MOX is a combination insecticide providing powerful control of termites, borers, and sucking pests. It offers quick knockdown with extended residual control."
    },
    {
        id: 137,
        name: "Double Attack",
        technical: "Emamectin Benzoate 1.9%",
        formulation: "EC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml, 100 ml, 20 ml",
        image: "/images/products/137.jpeg",
        description: "Double Attack is a highly effective insecticide for control of lepidopteran pests such as fruit borers and caterpillars. It provides fast action and long residual protection."
    },
    {
        id: 140,
        name: "AMBATHIO",
        technical: "Emamectin Benzoate 3% + Thiamethoxam 12%",
        formulation: "WG",
        category: "Insecticide",
        packSize: "1 kg, 500 gm, 250 gm, 100 gm",
        image: "/images/products/140.jpeg",
        description: "AMBATHIO is a dual-mode insecticide that controls caterpillars and sucking pests. It delivers quick knockdown and long-lasting protection for higher yield and better crop safety."
    },
    {
        id: 141,
        name: "ALLU-20",
        technical: "Metsulfuron Methyl 20%",
        formulation: "WP",
        category: "Herbicide",
        packSize: "8 gm",
        image: "/images/products/141.jpeg",
        description: "ALLU-20 is a highly effective post-emergence herbicide for control of broad-leaf weeds in wheat. It eliminates weed competition and helps crops achieve higher yield potential."
    },
    {
        id: 143,
        name: "CORFEEL",
        technical: "Cartap Hydrochloride 4% + Fipronil 0.5%",
        formulation: "CG",
        category: "Insecticide",
        packSize: "3 kg, 1 kg, 500 gm",
        image: "/images/products/143.jpeg",
        description: "CORFEEL is a granular insecticide for effective control of stem borers and soil insects in rice. It provides long-lasting protection and supports strong crop establishment."
    },
    {
        id: 144,
        name: "CARWEEL-3",
        technical: "Carbofuran 3%",
        formulation: "CG",
        category: "Insecticide",
        packSize: "5 kg, 3 kg, 1 kg",
        image: "/images/products/144.jpeg",
        description: "CARWEEL-3 is a granular insecticide for soil application to control nematodes, stem borers, and soil pests. It ensures early-stage protection and healthier crop growth."
    },
    {
        id: 146,
        name: "BEE",
        technical: "Bifenthrin 10%",
        formulation: "EC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml, 100 ml",
        image: "/images/products/146.jpeg",
        description: "BEE is a fast-acting pyrethroid insecticide for control of termites, borers, and sucking pests. It provides quick knockdown and long residual protection."
    },
    {
        id: 148,
        name: "CYMOS-10",
        technical: "Cypermethrin 10%",
        formulation: "EC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/148.jpeg",
        description: "CYMOS-10 is a broad-spectrum insecticide that controls a wide range of insect pests including bollworms, aphids, and jassids. It offers rapid action and dependable protection."
    },
    {
        id: 150,
        name: "TRIGO",
        technical: "Azoxystrobin 16.7% + Tricyclazole 33.3%",
        formulation: "SC",
        category: "Fungicide",
        packSize: "1 kg, 500 gm, 250 gm",
        image: "/images/products/150.jpeg",
        description: "TRIGO is a powerful combination fungicide for effective control of blast and other fungal diseases in rice. It provides preventive and curative protection for healthier crops and higher yield."
    },
    {
        id: 151,
        name: "MOX",
        technical: "Fipronil 4% + Thiamethoxam 4%",
        formulation: "SC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/151.jpeg",
        description: "MOX is a dual-action insecticide that controls termites, borers, and sucking pests. It ensures quick knockdown with long-lasting residual protection."
    },
    {
        id: 153,
        name: "Bani-D",
        technical: "Chlorpyriphos 1.5%",
        formulation: "DP",
        category: "Insecticide",
        packSize: "5 kg, 1 kg, 500 gm, 250 gm",
        image: "/images/products/153.jpeg",
        description: "Bani-D is a dust formulation insecticide for control of household and field pests. It provides quick knockdown and reliable protection against a wide range of insects."
    },
    {
        id: 154,
        name: "Kenal",
        technical: "Fenoxaprop-P-ethyl 10%",
        formulation: "EC",
        category: "Herbicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/154.jpeg",
        description: "Kenal is a selective post-emergence herbicide for control of grassy weeds in wheat and onion. It ensures clean fields and better crop performance."
    },
    {
        id: 155,
        name: "TUMIKA",
        technical: "Lambda-Cyhalothrin 10%",
        formulation: "WP",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/155.jpeg",
        description: "TUMIKA is a powerful insecticide for effective control of bollworms, caterpillars, and sucking pests. It provides quick action and long-lasting crop protection."
    },
    {
        id: 156,
        name: "ZOSHUAA",
        technical: "Oxyfluorfen 2.5% + Isopropyl amine salt of Glyphosate 41%",
        formulation: "SC",
        category: "Herbicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/156.jpeg",
        description: "ZOSHUAA is a broad-spectrum herbicide that controls both grassy and broad-leaf weeds. It provides fast desiccation and long-lasting weed control for clean fields."
    },
    {
        id: 157,
        name: "KINGO",
        technical: "Indoxacarb 14.5%",
        formulation: "SC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/157.jpeg",
        description: "KINGO is a highly effective insecticide for control of fruit borers and caterpillars. It provides fast action with long residual protection, ensuring healthy crops and higher yield."
    },
    {
        id: 158,
        name: "DEDLY",
        technical: "Fenpropathrin 10%",
        formulation: "EC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/158.jpeg",
        description: "DEDLY is a fast-acting insecticide for effective control of thrips, mites, and sucking pests. It delivers quick knockdown and extended residual control for reliable crop protection."
    },
    {
        id: 159,
        name: "VESKA",
        technical: "Propiconazole 13.9% + Difenoconazole 13.9%",
        formulation: "EC",
        category: "Fungicide",
        packSize: "1 L, 500 ml",
        image: "/images/products/159.jpeg",
        description: "VESKA is a powerful combination fungicide that provides preventive and curative control of rust, leaf spot, and powdery mildew. It improves plant health and ensures higher yield."
    },
    {
        id: 160,
        name: "Tej",
        technical: "Humic Acid 95%",
        formulation: "Powder",
        category: "Fertilizer",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/160.jpeg",
        description: "Tej is a high-purity humic acid fertilizer that improves soil structure, enhances nutrient uptake, and promotes strong root growth for better crop performance and yield."
    },
    {
        id: 162,
        name: "METWEEL",
        technical: "Thiamethoxam 0.9% + Fipronil 0.2%",
        formulation: "GR",
        category: "Insecticide",
        packSize: "1 Kg",
        image: "/images/products/162.jpeg",
        description: "METWEEL is a granular insecticide for control of termites and soil pests. It provides long-lasting protection and supports healthy crop establishment."
    },
    {
        id: 163,
        name: "PA7UM",
        technical: "Pymetrozine 50%",
        formulation: "WG",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/163.jpeg",
        description: "PA7UM is a systemic insecticide for effective control of sucking pests like aphids and whiteflies. It ensures quick action and prolonged protection."
    },
    {
        id: 164,
        name: "Weedza",
        technical: "Imazethapyr 10%",
        formulation: "SL",
        category: "Herbicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/164.jpeg",
        description: "Weedza is a selective herbicide for control of broad-leaf and grassy weeds in soybean and pulses. It ensures early weed management and higher crop productivity."
    },
    {
        id: 166,
        name: "GoodFan",
        technical: "Fenvalerate 20%",
        formulation: "EC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/166.jpeg",
        description: "GoodFan is a broad-spectrum insecticide for control of bollworms, caterpillars, and sucking pests. It provides fast knockdown and long residual protection."
    },
    {
        id: 167,
        name: "Corzeen",
        technical: "Chlorantraniliprole 18.5%",
        formulation: "SC",
        category: "Insecticide",
        packSize: "300 ml, 150 ml, 60 ml",
        image: "/images/products/167.jpeg",
        description: "Corzeen is a modern insecticide for effective control of lepidopteran pests. It offers long-lasting protection and helps achieve healthier crops with higher yield."
    },
    {
        id: 168,
        name: "Super-30",
        technical: "Imidacloprid 30.5%",
        formulation: "SC",
        category: "Insecticide",
        packSize: "1 Ltr",
        image: "/images/products/168.jpeg",
        description: "Super-30 is a systemic insecticide for control of sucking pests such as aphids, jassids, and whiteflies. It ensures strong protection and improved crop performance."
    },
    {
        id: 169,
        name: "DHAMAL",
        technical: "Amino Acid 45% + Fulvic Acid 25%",
        formulation: "Liquid",
        category: "Others",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/169.jpeg",
        description: "DHAMAL is a plant nutrition enhancer that improves nutrient absorption, boosts stress tolerance, and promotes vigorous growth for higher yield and better quality."
    },
    {
        id: 171,
        name: "Double Attack",
        technical: "Emamectin Benzoate 1.9%",
        formulation: "EC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml, 100 ml, 20 ml",
        image: "/images/products/171.jpeg",
        description: "Double Attack provides powerful control of fruit borers and caterpillars with fast action and long residual protection, ensuring maximum crop safety and productivity."
    },
    {
        id: 172,
        name: "TARGET",
        technical: "Emamectin Benzoate 1.5% + Fipronil 3.5%",
        formulation: "SC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/172.jpeg",
        description: "TARGET is a combination insecticide that controls both sucking and chewing pests. It delivers quick knockdown and extended protection for healthier crops."
    },
    {
        id: 174,
        name: "ALPLADU",
        technical: "Buprofezin 25%",
        formulation: "SC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/174.jpeg",
        description: "ALPLADU is a selective insecticide for effective control of whiteflies, hoppers, and sucking pests. It disrupts insect growth and provides long-lasting protection for healthier crops."
    },
    {
        id: 175,
        name: "SUPER NITRO",
        technical: "Flowering Agent (Natural Product)",
        formulation: "Liquid",
        category: "Others",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/175.jpeg",
        description: "SUPER NITRO is a natural flowering stimulant that promotes better flowering, fruit setting, and uniform crop development, resulting in higher yield and better quality produce."
    },
    {
        id: 176,
        name: "AGENT 5",
        technical: "Fipronil 5%",
        formulation: "SC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml, 100 ml",
        image: "/images/products/176.jpeg",
        description: "AGENT 5 is a powerful insecticide for control of termites, borers, and sucking pests. It offers quick knockdown and long residual protection for reliable crop safety."
    },
    {
        id: 179,
        name: "HUMIC GOLD",
        technical: "Humic Acid 15% + Amino Acid 10%",
        formulation: "Liquid",
        category: "Fertilizer",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/179.jpeg",
        description: "HUMIC GOLD improves soil fertility, enhances nutrient uptake, and promotes strong root development. It increases stress tolerance and boosts overall crop productivity."
    },
    {
        id: 181,
        name: "Silver Chloro",
        technical: "Chlorpyriphos 20%",
        formulation: "EC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/181.jpeg",
        description: "Silver Chloro is a broad-spectrum insecticide for control of termites, borers, and soil pests. It provides quick action and long-lasting protection for healthier crops."
    },
    {
        id: 182,
        name: "FOLIZOLE-25",
        technical: "Tebuconazole 25.9%",
        formulation: "EC",
        category: "Fungicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/182.jpeg",
        description: "FOLIZOLE-25 is a systemic fungicide that controls rust, leaf spot, and powdery mildew. It offers preventive and curative protection for improved crop health and yield."
    },
    {
        id: 183,
        name: "ETHOWEEL",
        technical: "Ethephon 39%",
        formulation: "SL",
        category: "Plant Growth Regulator",
        packSize: "1 L, 500 ml, 250 ml, 100 ml",
        image: "/images/products/183.jpeg",
        description: "ETHOWEEL promotes uniform flowering and fruit ripening, improves maturity, and enhances marketable yield in fruits and vegetables."
    },
    {
        id: 184,
        name: "CUSTADY",
        technical: "Azoxystrobin 11% + Tebuconazole 18.3%",
        formulation: "SC",
        category: "Fungicide",
        packSize: "1 L, 500 ml, 250 ml, 100 ml",
        image: "/images/products/184.jpeg",
        description: "CUSTADY is a combination fungicide providing strong control of leaf spot, rust, and blight. It ensures long-lasting protection and healthier, high-yielding crops."
    },
    {
        id: 185,
        name: "OCLEM",
        technical: "Emamectin Benzoate 5%",
        formulation: "SG",
        category: "Insecticide",
        packSize: "1 kg, 500 g",
        image: "/images/products/185.jpeg",
        description: "OCLEM is a highly effective insecticide for control of fruit borers and caterpillars. It provides fast action and long residual protection for maximum crop safety."
    },
    {
        id: 186,
        name: "SYMO-25",
        technical: "Cypermethrin 25%",
        formulation: "EC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/186.jpeg",
        description: "SYMO-25 is a powerful insecticide for control of a wide range of insect pests. It delivers quick knockdown and long-lasting protection across multiple crops."
    },
    {
        id: 187,
        name: "G-Cel",
        technical: "Glyphosate 41%",
        formulation: "SL",
        category: "Herbicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/187.jpeg",
        description: "G-Cel is a non-selective systemic herbicide for complete weed control. It effectively manages annual and perennial weeds, ensuring clean fields and better crop management."
    },
    {
        id: 188,
        name: "PEGO",
        technical: "Diafenthiuron 50%",
        formulation: "WP",
        category: "Insecticide",
        packSize: "1 Kg",
        image: "/images/products/188.jpeg",
        description: "PEGO is a contact and systemic insecticide for control of whiteflies, aphids, and mites. It provides long residual action and reliable pest management."
    },
    {
        id: 189,
        name: "Tagda",
        technical: "Novaluron 5.25% + Indoxacarb 4.5%",
        formulation: "SC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/189.jpeg",
        description: "Tagda is a dual-action insecticide for control of caterpillars and bollworms. It offers quick knockdown and extended protection for healthier crops."
    },
    {
        id: 190,
        name: "SUPER GREEN",
        technical: "Humic Acid 98%",
        formulation: "Powder",
        category: "Plant Growth Regulator",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/190.jpeg",
        description: "SUPER GREEN improves soil structure, enhances nutrient uptake, and promotes strong root growth, leading to higher yield and better crop quality."
    },
    {
        id: 191,
        name: "HUMIC GOLD",
        technical: "Humic Acid 15% + Amino Acid 10%",
        formulation: "Liquid",
        category: "Fertilizer",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/191.jpeg",
        description: "HUMIC GOLD boosts soil fertility, improves nutrient absorption, and supports vigorous plant growth for increased productivity and quality."
    },
    {
        id: 192,
        name: "PRO-404",
        technical: "Profenofos 40% + Cypermethrin 4%",
        formulation: "EC",
        category: "Insecticide",
        packSize: "1 Ltr",
        image: "/images/products/192.jpeg",
        description: "PRO-404 is a combination insecticide for effective control of bollworms and sucking pests. It provides rapid action and long-lasting protection for safer crops."
    },
    {
        id: 193,
        name: "AZOTHI",
        technical: "Azoxystrobin 2.5% + Thiophanate Methyl 11.25% + Thiamethoxam 25%",
        formulation: "FS",
        category: "Fungicide + Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/193.jpeg",
        description: "AZOTHI is a seed treatment formulation that protects seeds from fungal diseases and early-stage insect pests, ensuring healthy germination and strong crop establishment."
    },
    {
        id: 195,
        name: "DAIGEEL",
        technical: "Diafenthiuron 47% + Bifenthrin 9.4%",
        formulation: "SC",
        category: "Insecticide",
        packSize: "1 L",
        image: "/images/products/195.jpeg",
        description: "DAIGEEL is a powerful insecticide combination for control of whiteflies, mites, and sucking pests. It offers quick knockdown and long residual protection."
    },
    {
        id: 196,
        name: "Codi-15",
        technical: "Clodinafop-propargyl 15%",
        formulation: "WP",
        category: "Herbicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/196.jpeg",
        description: "Codi-15 is a selective post-emergence herbicide for control of grassy weeds in wheat. It ensures clean fields and better crop yield."
    },
    {
        id: 198,
        name: "Thayo",
        technical: "Thiamethoxam 25%",
        formulation: "WG",
        category: "Insecticide",
        packSize: "250 g, 100 g",
        image: "/images/products/198.jpeg",
        description: "Thayo is a systemic insecticide for effective control of sucking pests. It provides fast action and long-lasting protection for healthier crops."
    },
    {
        id: 200,
        name: "AGENT 5",
        technical: "Fipronil 5%",
        formulation: "SC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml, 100 ml",
        image: "/images/products/200.jpeg",
        description: "AGENT 5 provides powerful control of termites, borers, and sucking pests with quick knockdown and long residual protection for maximum crop safety."
    },
    {
        id: 202,
        name: "POTASH+",
        technical: "Water Soluble Potassium (K₂O)",
        formulation: "Liquid",
        category: "Fertilizer",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/202.jpeg",
        description: "POTASH+ is a premium potassium fertilizer that improves fruit size, colour, and quality. It enhances sugar movement, strengthens plant cells, and increases stress tolerance for higher yield and better market value."
    },
    {
        id: 204,
        name: "ZHA KAS",
        technical: "Humic Acid + Fulvic Acid + Amino Acid + Seaweed Extract",
        formulation: "Liquid",
        category: "Plant Growth Regulator",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/204.jpeg",
        description: "ZHA KAS is a complete plant bio-stimulant that improves root development, nutrient uptake, and plant immunity. It boosts flowering, fruit setting, and overall crop performance."
    },
    {
        id: 205,
        name: "AMBATHIO",
        technical: "Emamectin Benzoate 3% + Thiamethoxam 12%",
        formulation: "WG",
        category: "Insecticide",
        packSize: "1 kg, 500 gm, 250 gm, 100 gm",
        image: "/images/products/205.jpeg",
        description: "AMBATHIO is a powerful combination insecticide for control of caterpillars and sucking pests. It provides quick knockdown with long residual protection for maximum crop safety."
    },
    {
        id: 206,
        name: "Hodiyo Plus",
        technical: "Fungicidal Bio-Enhancer (Broad Spectrum)",
        formulation: "Liquid",
        category: "Fungicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/206.jpeg",
        description: "Hodiyo Plus is a bio-fungicide enhancer that strengthens plant resistance and controls a wide range of fungal diseases. It improves plant health and ensures better yield and quality."
    },
    {
        id: 209,
        name: "Thayo 75",
        technical: "Thiamethoxam 75%",
        formulation: "SG",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/209.jpeg",
        description: "Thayo 75 is a highly concentrated systemic insecticide for control of aphids, jassids, and whiteflies. It provides fast action and long-lasting protection for healthy crops."
    },
    {
        id: 211,
        name: "Cardro-50",
        technical: "Cartap Hydrochloride 50%",
        formulation: "SP",
        category: "Insecticide",
        packSize: "1 kg, 500 g, 250 g",
        image: "/images/products/211.jpeg",
        description: "Cardro-50 is a systemic insecticide for control of stem borers and leaf folders. It provides deep penetration and long residual control for strong crop protection."
    },
    {
        id: 213,
        name: "POWER",
        technical: "Silicone Based Super Spreader & Activator",
        formulation: "Liquid",
        category: "Others",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/213.jpeg",
        description: "POWER improves spray coverage, sticking, and penetration of agrochemicals. It enhances the performance of pesticides and fertilizers for better results."
    },
    {
        id: 214,
        name: "sipatu",
        technical: "Tebuconazole 10% + Sulphur 65%",
        formulation: "WG",
        category: "Fungicide",
        packSize: "1 Kg",
        image: "/images/products/214.jpeg",
        description: "sipatu is a dual-action fungicide for control of powdery mildew, rust, and leaf spot. It provides both preventive and curative disease protection."
    },
    {
        id: 216,
        name: "Dhamal",
        technical: "Amino Acid 45% + Fulvic Acid 25%",
        formulation: "Liquid",
        category: "Plant Growth Regulator",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/216.jpeg",
        description: "Dhamal enhances nutrient absorption, improves stress tolerance, and promotes vigorous plant growth for higher yield and better crop quality."
    },
    {
        id: 217,
        name: "Super Stop",
        technical: "Chlormequat Chloride 50%",
        formulation: "SL",
        category: "Plant Growth Regulator",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/217.jpeg",
        description: "Super Stop controls excessive vegetative growth and promotes strong stems and better flowering. It reduces lodging and improves yield potential."
    },
    {
        id: 219,
        name: "Guchar",
        technical: "Imidacloprid 48%",
        formulation: "FS",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/219.jpeg",
        description: "Guchar is a systemic seed treatment insecticide that protects crops from early-stage sucking pests, ensuring healthy germination and strong crop establishment."
    },
    {
        id: 220,
        name: "Hodiyo",
        technical: "Pyraclostrobin 20%",
        formulation: "WG",
        category: "Fungicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/220.jpeg",
        description: "Hodiyo is a modern fungicide that improves plant vitality while controlling rust, leaf spot, and powdery mildew for higher yield and better quality."
    },
    {
        id: 221,
        name: "Peno",
        technical: "Alpha Naphthyl Acetic Acid 4.5%",
        formulation: "SL",
        category: "Plant Growth Regulator",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/221.jpeg",
        description: "Peno promotes better flowering and fruit setting, reduces flower drop, and improves fruit size and quality for higher market value."
    },
    {
        id: 222,
        name: "Runner",
        technical: "Fipronil 2.92%",
        formulation: "EC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/222.jpeg",
        description: "Runner provides effective control of termites, stem borers, and sucking pests with quick knockdown and long residual protection."
    },
    {
        id: 224,
        name: "Tej",
        technical: "Humic Acid 98%",
        formulation: "Powder",
        category: "Plant Growth Regulator",
        packSize: "1 Kg, 500 g, 250 g",
        image: "/images/products/224.jpeg",
        description: "Tej improves soil structure, enhances nutrient uptake, and promotes strong root growth for better crop performance and higher yield."
    },
    {
        id: 225,
        name: "Power C",
        technical: "Glufosinate Ammonium 13.5% (15% w/v)",
        formulation: "SL",
        category: "Herbicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/225.jpeg",
        description: "Power C is a non-selective herbicide for quick control of existing weeds. It provides fast desiccation and effective weed management."
    },
    {
        id: 226,
        name: "Pronil",
        technical: "Acephate 50% + Fipronil 5%",
        formulation: "WDG",
        category: "Insecticide",
        packSize: "1 Kg",
        image: "/images/products/226.jpeg",
        description: "Pronil is a powerful combination insecticide for control of borers and sucking pests. It delivers fast action with long-lasting protection."
    },
    {
        id: 227,
        name: "Hexzo-75",
        technical: "Hexaconazole 75%",
        formulation: "WG",
        category: "Fungicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/227.jpeg",
        description: "Hexzo-75 is a highly concentrated systemic fungicide for control of powdery mildew, rust, and leaf spot with long residual protection."
    },
    {
        id: 229,
        name: "Pro-404",
        technical: "Profenofos 40% + Cypermethrin 4%",
        formulation: "EC",
        category: "Insecticide",
        packSize: "1 Ltr",
        image: "/images/products/229.jpeg",
        description: "Pro-404 provides strong control of bollworms and sucking pests with rapid action and long-lasting protection."
    },
    {
        id: 230,
        name: "Timbada",
        technical: "Paclobutrazole 40%",
        formulation: "SC",
        category: "Plant Growth Regulator",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/230.jpeg",
        description: "Timbada controls excessive vegetative growth and promotes better flowering and fruiting for improved crop architecture and yield."
    },
    {
        id: 233,
        name: "Abamin",
        technical: "Abamectin 1.9%",
        formulation: "EC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml, 100 ml",
        image: "/images/products/233.jpeg",
        description: "Abamin is a powerful acaricide and insecticide for control of mites, thrips, and leaf miners with quick action and long residual effect."
    },
    {
        id: 234,
        name: "Odin",
        technical: "Buprofezin 20% + Acephate 50%",
        formulation: "WP",
        category: "Insecticide",
        packSize: "1 Kg",
        image: "/images/products/234.jpeg",
        description: "Odin is a dual-action insecticide for control of hoppers, whiteflies, and leaf miners with reliable and long-lasting protection."
    },
    {
        id: 235,
        name: "Koweel",
        technical: "Chlorothalonil 75%",
        formulation: "WP",
        category: "Fungicide",
        packSize: "250 g",
        image: "/images/products/235.jpeg",
        description: "Koweel is a broad-spectrum contact fungicide for control of blight, leaf spot, and fruit rot, ensuring healthy crops and higher yield."
    },
    {
        id: 236,
        name: "Peter-4G",
        technical: "Chlorantraniliprole 0.4%",
        formulation: "GR",
        category: "Insecticide",
        packSize: "4 Kg",
        image: "/images/products/236.jpeg",
        description: "Peter-4G is a granular insecticide for control of stem borers and caterpillars, providing long-lasting soil protection."
    },
    {
        id: 237,
        name: "Liger",
        technical: "Lambda Cyhalothrin 2.5%",
        formulation: "EC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/237.jpeg",
        description: "Liger is a fast-acting insecticide for control of bollworms and sucking pests with quick knockdown and residual protection."
    },
    {
        id: 238,
        name: "One Weel",
        technical: "Quizalofop Ethyl 4% + Oxyfluorfen 6%",
        formulation: "EC",
        category: "Herbicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/238.jpeg",
        description: "One Weel is a dual-action herbicide for control of grassy and broad-leaf weeds, ensuring clean fields and better crop growth."
    },
    {
        id: 240,
        name: "Sport",
        technical: "Acephate 75%",
        formulation: "SP",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/240.jpeg",
        description: "Sport is a systemic insecticide for effective control of sucking and chewing pests with quick action and long residual protection."
    },
    {
        id: 241,
        name: "Sitora",
        technical: "Azadirachtin 1% (10000 ppm)",
        formulation: "EC",
        category: "Insecticide",
        packSize: "1 Ltr",
        image: "/images/products/241.jpeg",
        description: "Sitora is a neem-based insecticide for eco-friendly control of sucking pests and caterpillars, safe for beneficial insects."
    },
    {
        id: 242,
        name: "Pisoty-55",
        technical: "Sulphur 55.16%",
        formulation: "SC",
        category: "Fungicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/242.jpeg",
        description: "Pisoty-55 controls powdery mildew and mite infestation while correcting sulphur deficiency for healthier and greener crops."
    },
    {
        id: 243,
        name: "Adino",
        technical: "Permethrin 25%",
        formulation: "EC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/243.jpeg",
        description: "Adino is a fast-acting insecticide for control of flies, mosquitoes, and crop pests with strong knockdown effect."
    },
    {
        id: 244,
        name: "Potash",
        technical: "Water Soluble Potassium (K₂O)",
        formulation: "Liquid",
        category: "Plant Growth Regulator",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/244.jpeg",
        description: "Potash improves fruit development, colour, and shelf life by supplying readily available potassium for better crop quality and yield."
    },
    {
        id: 245,
        name: "Kyle",
        technical: "Diafenthiuron 40.1% + Acetamiprid 3.9%",
        formulation: "WP",
        category: "Insecticide",
        packSize: "1 Kg",
        image: "/images/products/245.jpeg",
        description: "Kyle is a combination insecticide for control of whiteflies, aphids, and mites with quick knockdown and long residual protection."
    },
    {
        id: 247,
        name: "G-Tech",
        technical: "Amino Acid & Vitamins",
        formulation: "Liquid",
        category: "Plant Growth Regulator",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/247.jpeg",
        description: "G-Tech improves plant metabolism, enhances stress tolerance, and boosts growth and yield through balanced nutrition support."
    },
    {
        id: 248,
        name: "Sabuka",
        technical: "Difenoconazole 25%",
        formulation: "EC",
        category: "Fungicide",
        packSize: "1 Ltr",
        image: "/images/products/248.jpeg",
        description: "Sabuka is a systemic fungicide for control of leaf spot, rust, and powdery mildew with long-lasting protection."
    },
    {
        id: 249,
        name: "Weelora",
        technical: "Quizalofop Ethyl 10%",
        formulation: "EC",
        category: "Herbicide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/249.jpeg",
        description: "Weelora is a selective post-emergence herbicide for control of grassy weeds, ensuring clean fields and better crop yield."
    },
    {
        id: 251,
        name: "Karnol",
        technical: "Fenoxaprop-p-ethyl 10%",
        formulation: "EC",
        category: "Herbicide",
        packSize: "1 Ltr",
        image: "/images/products/251.jpeg",
        description: "Karnol effectively controls grassy weeds in wheat and onion, providing clean fields and improved crop performance."
    },
    {
        id: 252,
        name: "Retar",
        technical: "Clodinafop Propargyl 9% + Metribuzin 20%",
        formulation: "WP",
        category: "Herbicide",
        packSize: "250 g",
        image: "/images/products/252.jpeg",
        description: "Retar is a combination herbicide for control of grassy and broad-leaf weeds, ensuring weed-free fields and higher yield."
    },
    {
        id: 254,
        name: "Niyo",
        technical: "Fenpyroximate 5%",
        formulation: "EC",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/254.jpeg",
        description: "Niyo is an acaricide for control of mites and sucking pests, providing fast action and long residual control."
    },
    {
        id: 255,
        name: "Adweel",
        technical: "Imidacloprid 70%",
        formulation: "WG",
        category: "Insecticide",
        packSize: "150 gm, 60 gm, 30 gm",
        image: "/images/products/255.jpeg",
        description: "Adweel is a high-strength systemic insecticide for control of sucking pests with quick action and long-lasting protection."
    },
    {
        id: 256,
        name: "Picasu",
        technical: "Cymoxanil 50%",
        formulation: "WP",
        category: "Fungicide",
        packSize: "1 Kg",
        image: "/images/products/256.jpeg",
        description: "Picasu is a curative fungicide for control of late blight and downy mildew, providing rapid disease suppression."
    },
    // {
    //     id: 258,
    //     name: "Tagda",
    //     technical: "Bispyribac Sodium 10%",
    //     formulation: "SC",
    //     category: "Herbicide",
    //     packSize: "1 L, 500 ml, 250 ml",
    //     image: "/images/products/258.jpeg",
    //     description: "Mini Gold is a selective herbicide for control of grassy and broad-leaf weeds in rice, ensuring clean fields and higher yield."
    // },
    {
        id: 259,
        name: "Metal 35",
        technical: "Metalaxyl 35%",
        formulation: "WS",
        category: "Fungicide",
        packSize: "1 kg, 500 gm",
        image: "/images/products/259.jpeg",
        description: "Metal 35 is a systemic fungicide for seed and soil treatment to control damping-off and downy mildew, ensuring healthy crop establishment."
    },
    {
        id: 260,
        name: "Lopamudra",
        technical: "Acephate 50% + Imidacloprid 1.8%",
        formulation: "SP",
        category: "Insecticide",
        packSize: "1 L, 500 ml, 250 ml",
        image: "/images/products/260.jpeg",
        description: "Lopamudra is a combination insecticide for effective control of sucking and chewing pests with quick knockdown and long residual protection."
    },
    {
        id: 261,
        name: "Harry-Go NPK 20:20:20",
        technical: "Nitrogen 20% + Phosphorus 20% + Potassium 20%",
        formulation: "Water Soluble Powder",
        category: "NPK Fertilizer",
        packSize: "1 Kg",
        image: "/images/products/261.jpg",
        description: "Harry-Go NPK 20:20:20 is a balanced water-soluble fertilizer suitable for all crops. It supports strong vegetative growth, improves flowering and fruit development, enhances nutrient uptake, and ensures uniform crop growth throughout different growth stages."
    },
    {
        id: 262,
        name: "Harry-Go Calcium Nitrate",
        technical: "Calcium Nitrate",
        formulation: "Water Soluble Granules",
        category: "NPK Fertilizer",
        packSize: "1 Kg",
        image: "/images/products/262.jpg",
        description: "Harry-Go Calcium Nitrate provides readily available calcium and nitrate nitrogen for crops. It strengthens cell walls, improves fruit firmness and shelf life, prevents cracking and blossom end rot, and enhances overall crop quality and yield."
    },
    {
        id: 263,
        name: "Harry-Go NPK 19:19:19",
        technical: "Nitrogen 19% + Phosphorus 19% + Potassium 19%",
        formulation: "Water Soluble Powder",
        category: "NPK Fertilizer",
        packSize: "1 Kg",
        image: "/images/products/263.jpg",
        description: "Harry-Go NPK 19:19:19 delivers equal proportions of essential nutrients for balanced crop nutrition. It promotes healthy root growth, better flowering, improved fruit setting, and sustained plant vigor during early and mid growth stages."
    },
    {
        id: 264,
        name: "Harry-Go Boron 20%",
        technical: "Disodium Octaborate Tetrahydrate",
        formulation: "Water Soluble Powder",
        category: "NPK Fertilizer",
        packSize: "1 Kg",
        image: "/images/products/264.jpg",
        description: "Harry-Go Boron 20% helps correct boron deficiency in crops. It improves pollen viability, flower retention, seed and fruit formation, and enhances overall crop quality, yield, and uniform growth across a wide range of crops."
    },
    {
        id: 265,
        name: "Harry-Go NPK 13:00:45",
        technical: "Potassium Nitrate",
        formulation: "Water Soluble Powder",
        category: "NPK Fertilizer",
        packSize: "1 Kg",
        image: "/images/products/265.jpg",
        description: "Harry-Go NPK 13:00:45 is a high potassium fertilizer that enhances fruit size, color, sweetness, and shelf life. It improves stress tolerance, supports flowering and fruiting, and ensures better crop quality in fruits and vegetables."
    },
    {
        id: 266,
        name: "Harry-Go NPK 13:40:13",
        technical: "Nitrogen 13% + Phosphorus 40% + Potassium 13%",
        formulation: "Water Soluble Powder",
        category: "NPK Fertilizer",
        packSize: "1 Kg",
        image: "/images/products/266.jpg",
        description: "Harry-Go NPK 13:40:13 is specially formulated to encourage strong root development and early flowering. Its high phosphorus content improves nutrient absorption, crop establishment, and overall plant strength during early growth stages."
    },
    {
        id: 267,
        name: "Harry-Go NPK 00:52:34",
        technical: "Mono Potassium Phosphate",
        formulation: "Water Soluble Powder",
        category: "NPK Fertilizer",
        packSize: "1 Kg",
        image: "/images/products/267.jpg",
        description: "Harry-Go NPK 00:52:34 is a nitrogen-free fertilizer ideal for flowering and fruiting stages. It supplies high phosphorus and potassium, improves flower initiation, fruit setting, size, color, and enhances overall yield and quality."
    },
    {
        id: 268,
        name: "Harry-Go NPK 16:08:24",
        technical: "Nitrogen 16% + Phosphorus 8% + Potassium 24%",
        formulation: "Water Soluble Powder",
        category: "NPK Fertilizer",
        packSize: "1 Kg",
        image: "/images/products/268.jpg",
        description: "Harry-Go NPK 16:08:24 provides balanced nutrition with higher potassium to improve crop vigor and productivity. It enhances plant health, supports flowering and fruit development, and helps crops withstand environmental and physiological stress."
    },
    {
        id: 269,
        name: "Harry-Go NPK 00:00:50",
        technical: "Potassium Sulphate",
        formulation: "Water Soluble Powder",
        category: "NPK Fertilizer",
        packSize: "1 Kg",
        image: "/images/products/269.jpg",
        description: "Harry-Go NPK 00:00:50 supplies high potassium and sulphur for quality produce. It improves fruit firmness, taste, color, oil content, and increases resistance to diseases and adverse environmental conditions."
    },
    {
        id: 270,
        name: "Harry-Go NPK 28:28:00",
        technical: "Nitrogen 28% + Phosphorus 28%",
        formulation: "Water Soluble Powder",
        category: "NPK Fertilizer",
        packSize: "1 Kg",
        image: "/images/products/270.jpg",
        description: "Harry-Go NPK 28:28:00 is ideal for early crop stages, promoting rapid vegetative growth and strong root development. It improves nutrient uptake, plant establishment, and prepares crops for higher productivity in later growth stages."
    },
    {
        id: 271,
        name: "Harry-Go Chelated Multi Micronutrient",
        technical: "Chelated Zinc, Iron, Manganese, Copper, Boron & Molybdenum",
        formulation: "Water Soluble Powder",
        category: "NPK Fertilizer",
        packSize: "1 Kg",
        image: "/images/products/271.jpg",
        description: "Harry-Go Chelated Multi Micronutrient provides essential trace elements in chelated form for quick absorption. It corrects micronutrient deficiencies, improves chlorophyll formation, enhances plant metabolism, and supports healthy growth, flowering, and higher yields in all field and horticultural crops."
    },
    {
        id: 272,
        name: "Harry-Go NPK 17:44:00",
        technical: "Urea Phosphate",
        formulation: "Water Soluble Powder",
        category: "NPK Fertilizer",
        packSize: "1 Kg",
        image: "/images/products/272.jpg",
        description: "Harry-Go NPK 17:44:00 is a highly acidic, water-soluble fertilizer supplying nitrogen and high phosphorus. It promotes strong root development, early crop establishment, and efficient nutrient uptake, making it ideal for drip irrigation, fertigation, and foliar application."
    },
    {
        id: 273,
        name: "Harry-Go NPK 00:60:20",
        technical: "Phosphorus 60% + Potassium 20%",
        formulation: "Water Soluble Powder",
        category: "NPK Fertilizer",
        packSize: "1 Kg",
        image: "/images/products/273.jpg",
        description: "Harry-Go NPK 00:60:20 is a nitrogen-free fertilizer rich in phosphorus and potassium. It supports flowering, fruit setting, and root strength while ensuring controlled vegetative growth and improved yield quality during reproductive crop stages."
    },
    {
        id: 274,
        name: "Harry-Go NPK 00:00:23",
        technical: "Potassium Schoenite",
        formulation: "Water Soluble Powder",
        category: "NPK Fertilizer",
        packSize: "1 Kg",
        image: "/images/products/274.jpg",
        description: "Harry-Go NPK 00:00:23 supplies potassium along with magnesium and sulphur for balanced plant nutrition. It enhances fruit quality, improves oil and sugar content, increases stress tolerance, and supports healthy crop growth across various stages."
    },
    {
        id: 275,
        name: "Harry-Go NPK 12:61:00",
        technical: "Mono Ammonium Phosphate",
        formulation: "Water Soluble Powder",
        category: "NPK Fertilizer",
        packSize: "1 Kg",
        image: "/images/products/275.jpg",
        description: "Harry-Go NPK 12:61:00 is a high phosphorus fertilizer that encourages rapid root development and early flowering. It improves nutrient absorption, crop establishment, and is highly suitable for fertigation, drip systems, and foliar application."
    },
    {
        id: 276,
        name: "Harry-Go Boron 10.5%",
        technical: "Sodium Tetraborate",
        formulation: "Water Soluble Powder",
        category: "NPK Fertilizer",
        packSize: "1 Kg",
        image: "/images/products/276.jpg",
        description: "Harry-Go Boron 10.5% effectively corrects boron deficiency in crops. It improves pollen viability, flower retention, fruit and seed formation, and enhances overall crop quality, yield uniformity, and physiological plant functions."
    },
    {
        id: 277,
        name: "Harry-Go Amino Shiny Ball",
        technical: "Amino Acids, Humic Acid, Nitrogen, Phosphorus & Potassium",
        formulation: "Water Soluble Granules",
        category: "NPK Fertilizer",
        packSize: "1 Kg",
        image: "/images/products/277.jpg",
        description: "Harry-Go Amino Shiny Ball is a plant growth stimulant enriched with amino acids and nutrients. It improves root development, enhances flowering, improves soil condition, reduces fertilizer stress, and supports better nutrient efficiency in all crops."
    },
    {
        id: 278,
        name: "Harry-Go Manganese Sulphate",
        technical: "Manganese Sulphate",
        formulation: "Water Soluble Powder",
        category: "NPK Fertilizer",
        packSize: "1 Kg",
        image: "/images/products/278.jpg",
        description: "Harry-Go Manganese Sulphate corrects manganese deficiency and improves photosynthesis. It supports enzyme activation, enhances chlorophyll production, strengthens plant metabolism, and improves crop health, quality, and yield in diverse crops."
    },
    {
        id: 279,
        name: "Harry-Go Zinc Sulphate Heptahydrate",
        technical: "Zinc Sulphate Heptahydrate",
        formulation: "Water Soluble Crystals",
        category: "NPK Fertilizer",
        packSize: "1 Kg",
        image: "/images/products/279.jpg",
        description: "Harry-Go Zinc Sulphate Heptahydrate provides readily available zinc to crops. It improves enzyme activity, hormone balance, growth regulation, and helps prevent zinc deficiency, leading to better plant vigor and improved yields."
    },
    {
        id: 280,
        name: "Harry-Go Sulphur 90 Granular",
        technical: "Elemental Sulphur 90%",
        formulation: "Granular",
        category: "NPK Fertilizer",
        packSize: "1 Kg",
        image: "/images/products/280.jpg",
        description: "Harry-Go Sulphur 90 Granular supplies high elemental sulphur for long-lasting soil nutrition. It improves nutrient uptake, enhances crop quality, supports oilseed production, and helps correct sulphur deficiency in alkaline and sulphur-deficient soils."
    },
    {
        id: 281,
        name: "Harry-Go Zinc Sulphate 33% Monohydrate",
        technical: "Zinc Sulphate Monohydrate (Zn 33%)",
        formulation: "Water Soluble Crystals",
        category: "NPK Fertilizer",
        packSize: "1 Kg",
        image: "/images/products/281.jpg",
        description: "Harry-Go Zinc Sulphate 33% Monohydrate is a highly concentrated zinc fertilizer used to correct zinc deficiency in crops. It enhances enzyme activity, chlorophyll formation, and hormone balance, resulting in improved plant growth, vigor, and higher yields."
    },
    {
        id: 282,
        name: "Harry-Go Magnesium Sulphate",
        technical: "Magnesium Sulphate (MgSO4)",
        formulation: "Water Soluble Crystals",
        category: "NPK Fertilizer",
        packSize: "1 Kg",
        image: "/images/products/282.jpg",
        description: "Harry-Go Magnesium Sulphate supplies essential magnesium and sulphur required for chlorophyll formation and photosynthesis. It helps correct magnesium deficiency, improves leaf color, enhances nutrient uptake, and supports healthy growth and yield in various crops."
    },
    {
        id: 283,
        name: "Harry-Go Copper Sulphate",
        technical: "Copper Sulphate",
        formulation: "Water Soluble Crystals",
        category: "NPK Fertilizer",
        packSize: "1 Kg",
        image: "/images/products/283.jpg",
        description: "Harry-Go Copper Sulphate provides copper, an essential micronutrient for plant metabolism and enzyme activation. It helps correct copper deficiency, supports chlorophyll formation, improves disease resistance, and enhances overall crop growth and productivity."
    },
    {
        id: 284,
        name: "Harry-Go Ammonium Sulphate",
        technical: "Ammonium Nitrogen 20.6% + Sulphur 23%",
        formulation: "Water Soluble Crystals",
        category: "NPK Fertilizer",
        packSize: "1 Kg",
        image: "/images/products/284.jpg",
        description: "Harry-Go Ammonium Sulphate is a dual nutrient fertilizer supplying nitrogen and sulphur. It improves vegetative growth, enhances protein synthesis, lowers soil pH in alkaline soils, and supports better nutrient availability and crop yield."
    },
    {
        id: 285,
        name: "Harry-Go Ferrous Sulphate",
        technical: "Ferrous Sulphate (Iron Sulphate)",
        formulation: "Water Soluble Crystals",
        category: "NPK Fertilizer",
        packSize: "1 Kg",
        image: "/images/products/285.jpg",
        description: "Harry-Go Ferrous Sulphate is an effective source of iron for correcting iron chlorosis in crops. It promotes chlorophyll synthesis, improves photosynthesis, enhances plant vigor, and supports healthy growth in iron-deficient soils."
    }
];

export default products;